// extracted by mini-css-extract-plugin
export default {"suggestedTopics":"SuggestedTopics_suggestedTopics__NnLh-"};